function l(e) {
  return new DOMParser().parseFromString(e || "", "text/html").documentElement.textContent || "";
}
function s(e) {
  const t = {
    "¢": "cent",
    "£": "pound",
    "¥": "yen",
    "€": "euro",
    "©": "copy",
    "®": "reg",
    "<": "lt",
    ">": "gt",
    '"': "quot",
    "&": "amp",
    "'": "#39",
    // prevent XSS from vue bracket injection for network activity dynamic component
    "{": "#123",
    "}": "#125"
  }, n = `[${Object.keys(t).reduce((r, c) => r + c)}]`, o = new RegExp(n, "g");
  return (e || "").replace(o, (r) => `&${t[r]};`);
}
function i(e) {
  const t = e.style.overflow;
  (!t || t === "visible") && (e.style.overflow = "hidden");
  const n = e.clientWidth < e.scrollWidth || e.clientHeight < e.scrollHeight;
  return e.style.overflow = t, n;
}
function u(e) {
  const t = /(data-[^=]*)="(\\&#34;)?([^(\\|")]*)(\\&#34;)?"/gi;
  return e.replaceAll(t, (n) => n.replaceAll("\\&#34;", ""));
}
function a(e) {
  const t = />( +)<\//g;
  return e.replaceAll(t, (n) => n.replaceAll(" ", "&nbsp;"));
}
export {
  s as encodeHTMLEntities,
  a as fillSpaceBetweenTags,
  u as fixBrokenQuote,
  i as hasOverflow,
  l as unescapeHTML
};
